var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#061A11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 41.6289V22.3711C48.7485 22.0929 48.6737 21.8201 48.5331 21.58C48.3925 21.34 48.1911 21.1413 47.9492 21.0039L30.7617 11.3359C30.5301 11.2022 30.2674 11.1318 30 11.1318C29.7326 11.1318 29.4699 11.2022 29.2383 11.3359L12.0508 21.0039C11.8089 21.1413 11.6075 21.34 11.4669 21.58C11.3263 21.8201 11.2515 22.0929 11.25 22.3711V41.6289C11.2515 41.9071 11.3263 42.1799 11.4669 42.42C11.6075 42.66 11.8089 42.8587 12.0508 42.9961L29.2383 52.6641C29.4699 52.7978 29.7326 52.8682 30 52.8682C30.2674 52.8682 30.5301 52.7978 30.7617 52.6641L47.9492 42.9961C48.1911 42.8587 48.3925 42.66 48.5331 42.42C48.6737 42.1799 48.7485 41.9071 48.75 41.6289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5703 36.7852V26.6289L20.625 16.1797",
    stroke: "#061A11",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5352 21.5702L30.1758 31.9999L11.4648 21.5702",
    stroke: "#061A11",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1758 32L30 52.8594",
    stroke: "#061A11",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB5);
export default __webpack_public_path__ + "static/media/b5.f019eda0fd688c9a4addfa0f94464165.svg";
export { ForwardRef as ReactComponent };